/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_DescriptionInputs */

const zh_subscription_description = /** @type {(inputs: Subscription_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理您的订阅计划和账单信息。`)
};

const en_subscription_description = /** @type {(inputs: Subscription_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your subscription plans and billing information.`)
};

const es_subscription_description = /** @type {(inputs: Subscription_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tus planes de suscripción e información de facturación.`)
};

/**
* | output |
* | --- |
* | "Manage your subscription plans and billing information." |
*
* @param {Subscription_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_description = /** @type {((inputs?: Subscription_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_description(inputs)
	if (locale === "en") return en_subscription_description(inputs)
	return es_subscription_description(inputs)
});